import './Services.scss';
import Loader from 'react-loaders';
import { Link } from 'react-router-dom';
import feauturesImg from '../../assets/img/feauturesimg.jpg'

const Services = () => {
  return (
    <>
      <div className='container services'>
        <h1 className='title'><span>у</span>слуги</h1>

        <section className='services'>
          <img src={feauturesImg} alt="img" className='services__img'/>

          <div className='services__cards'>
            <div className='services__card card'>
              <h3 className='card-title services__title '>Автоматизация учета</h3>
              <p className='card-text'>Мы поможем провести обследование вашего учета, сформируем предложения по его автоматизации и реализуем их на базе вашей учетной системы 1С.</p>
              <p></p>
			  <p className='card-text'><strong>Стоимость часа работы "1С:Специалиста" — 4200 рублей с НДС</strong></p>
              <Link to='/contact'  className='link'>Заказать</Link>
            </div>

            <div className='services__card card'>
              <h3 className=' card-title services__title'>IT аутсорсинг. Абонентское обслуживание</h3>
              <p className='card-text'>Заключим договор на абонентское обслуживание, проведем аудит состояния системы, закрепим за компанией ответственного специалиста, который поможет решать текущие проблемы.</p>
			  <p></p>
			  <p className='card-text'><strong>Цена от 25000 рублей в месяц, в зависимости от объема ежемесячных работ</strong></p>
              <Link to='/contact' className='link'>Заказать</Link>
            </div>

            <div className='services__card card'>
              <h3 className='card-title services__title'>Оптимизация производительности</h3>
              <p className='card-text'>Оценим узкие места вашей 1С, сформулируем способы оптимизации, ускорим работу программы. Стоимость часа работы специалиста — 6500 рублей с НДС.</p>
              <p></p>
			  <p className='card-text'><strong>Стоимость часа работы "1С:Эксперта по технологическим вопросам" — 6500 рублей с НДС</strong></p>
			  <Link to='/contact'  className='link'>Заказать</Link>
            </div>

            <div className='services__card card'>
              <h3 className='card-title services__title'>Проектные решения</h3>
              <p className='card-text'>Подберем для вашей компании типовое решение 1С, которое максимально отвечает потребностям, поможем его внедрить и ввести в эксплуатацию. </p>
              <p></p>
			  <p className='card-text'><strong>Стоимость часа работы "1С:Специалист-консультант" — 4200 рублей с НДС</strong></p>
              <Link to='/contact'  className='link'>Заказать</Link>
            </div>
          </div>
        </section>
      </div>
      <Loader type="ball-pulse"/>
    </>
  )
}

export default Services;